/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Typography, Chip, Button, Dialog, DialogActions, DialogContent, FormHelperText } from "@mui/material";

export const CitiesContainer = styled('div')({
  height: '100%',
  width: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
})

export const StyledTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: '700',
  lineHeight: '40px',
  padding: '20px 0px 10px 0px',
})

export const StyledTableSection = styled('div')({
  padding: '20px 0px',
})

export const StyledDefaultChip = styled(Chip)({
  backgroundColor: '#e8edfa',
  color: '#2b4fb9',
  fontWeight: 600,
})

export const StyledActionBar = styled('div')({
  padding: '20px 0px 0px 0px',
})

export const CityDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    borderRadius: '12px',
  },
})

export const CityDialogHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 20px',
  borderBottom: '1px solid #e5e7eb',
})

export const CityDialogTitle = styled(Typography)({
  fontSize: '22px',
  fontWeight: 700,
  color: 'rgba(81, 81, 82, 1)',
})

export const CityDialogContent = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: '20px !important',
})

export const CitySectionTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 700,
  color: '#111827',
})

export const CityHelperText = styled(FormHelperText)({
  marginLeft: 0,
  marginTop: 0,
  marginBottom: '10px',
})

export const CityFieldGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '16px',
  '@media (max-width: 600px)': {
    gridTemplateColumns: '1fr',
  },
})

export const CityDialogActions = styled(DialogActions)({
  padding: '15px 20px',
  borderTop: '1px solid #e5e7eb',
  justifyContent: 'space-between',
})

export const CityFillButton = styled(Button)({
  height: '40px',
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: '8px',
})
